import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import Link from '@stubhub/react-formatted-link';

import {getAppDownloadLink, getSocialLink} from './footer-social-data';

const FooterSocial = (props, context) => {
  const {globalRegistry} = context || {};

  const locale = globalRegistry.getDefaultLocale() || 'en-US';
  const currentLocale = globalRegistry.getCurrentLocale() || 'en-US';
  const storeId = globalRegistry.getStoreId();
  const showAppBadges = !!globalRegistry.getFeatureValue('common.footer.showAppDownloadLink');
  const isFacebookEnabled = !!globalRegistry.getFeatureValue('common.footer.showFacebookButton');
  const isTwitterEnabled = !!globalRegistry.getFeatureValue('common.footer.showTwitterButton');
  const isInstagramEnabled = !!globalRegistry.getFeatureValue('common.footer.showInstagramButton');
  const isLinkedinEnabled = !!globalRegistry.getFeatureValue('common.footer.showLinkedinButton');

  const shouldShowSocial = isFacebookEnabled || isTwitterEnabled || isInstagramEnabled || isLinkedinEnabled;
  const shouldRender = showAppBadges || shouldShowSocial;

  if (!shouldRender) {
    return null;
  }

  const {facebook, twitter, instagram, linkedin} = getSocialLink(storeId, locale);
  const {android, ios} = getAppDownloadLink(storeId, locale);
  const iosBadgeClass = storeId === 1 ? `iosapp-${currentLocale}` : `iosapp-${locale}`;
  const androidBadgeClass = storeId === 1 ? `androidapp-${currentLocale}` : `androidapp-${locale}`;

  return (
    <div className="footer-social-app footer-download">
      {shouldShowSocial && (
        <div className="footer-social">
          {isFacebookEnabled && (
            <Link
              className="footer-social-link footer-facebook"
              href={facebook}
              title="Facebook"
              data-title="Facebook"
              externalLink
              target="_blank"
            >
              <Icon name="FacebookFlat" size="md" />
            </Link>
          )}
          {isTwitterEnabled && (
            <Link
              className="footer-social-link footer-twitter"
              href={twitter}
              title="Twitter"
              data-title="Twitter"
              externalLink
              target="_blank"
            >
              <Icon name="TwitterFlat" size="md" />
            </Link>
          )}
          {isInstagramEnabled && (
            <Link
              className="footer-social-link footer-instagram"
              href={instagram}
              title="Instagram"
              data-title="Instagram"
              externalLink
              target="_blank"
            >
              <Icon name="InstagramFlat" size="md" />
            </Link>
          )}
          {isLinkedinEnabled && (
            <Link
              className="footer-social-link footer-linkedin"
              href={linkedin}
              title="Linkedin"
              data-title="Linkedin"
              externalLink
              target="_blank"
            >
              <Icon name="LinkedInFlat" size="md" />
            </Link>
          )}
        </div>
      )}
      {showAppBadges && (
        <div className="footer-app-download">
          <div className="ios-android-app-download">
            <Link
              className={`iosapp ${iosBadgeClass}`}
              title="ios-app download"
              target="_blank"
              rel="noopener noreferrer"
              href={ios}
              externalLink
            >
              <FormattedMessage id="Footer.downloadIOSApp" defaultMessage="Download on the App Store" />
            </Link>
            <Link
              className={`androidapp ${androidBadgeClass}`}
              title="android-app download"
              target="_blank"
              rel="noopener noreferrer"
              href={android}
              externalLink
            >
              <FormattedMessage id="Footer.downloadAndroidApp" defaultMessage="GET IT ON Google Play" />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

FooterSocial.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default injectIntl(FooterSocial);
